<template>
    <div v-if="preloader">
        <template>
        <v-dialog v-model="preloader" hide-overlay persistent width="300">
            <v-progress-linear indeterminate></v-progress-linear>
        </v-dialog>
        </template>
    </div>
    <div class="view-assessment-card" v-else>
    <v-card
      height="64px"
      width="100%"
      class="background ml-4 mr-6 my-0 px-4 transparent elevation-0 d-flex flex-row justify-space-between align-center"
      style="position: fixed;z-index: 200;top: 0;width: 98%;padding-top: 8px;">
        <v-card-title class="ml-0">
            <span
            @click="$router.push('/static-assessment')"
            class="breadcrumb-text cursor underline-on-hover"
            >
            Assessment
            </span>
            <v-icon class="breadcrumb-arrow">mdi-chevron-right</v-icon>
            <p class="breadcrumb-text">
                 View Assessment
            </p>
            <span><v-icon class="breadcrumb-arrow">mdi-chevron-down</v-icon></span>
        </v-card-title>
        <UserNavMenu />
        </v-card>
        <v-card outlined rounded class="ml-4 mr-6 pa-6 elevation-0 gap-8 d-flex flex-column justify-space-between align-center">
            <v-row class="w-100">
                <v-col cols="6">
                    <div class="d-flex flex-column gap-3">
                        <div class="text-caption view-field-title">
                            Assessment Mode
                        </div>
                        <div class="text-body-2 font-weight-bold view-field-value">
                            {{ assessmentData?.modeOfAssessment }}
                        </div>
                    </div>
                </v-col>
                <v-col cols="6">
                    <div class="d-flex flex-column gap-3">
                        <div class="text-caption view-field-title">
                            Assessment Name
                        </div>
                        <div class="text-body-2 font-weight-bold view-field-value">
                            {{ assessmentData?.assessmentName }}
                        </div>
                    </div>
                </v-col>
            </v-row>

            <v-row class="w-100">
                <v-col cols="12">
                    <div class="d-flex flex-column gap-3">
                        <div class="text-caption view-field-title">
                            Assessment Description
                        </div>
                        <div class="text-body-2 font-weight-bold view-field-value" v-html=" assessmentData?.assessmentDescription">
                        </div>
                    </div>
                </v-col>
            </v-row>

             <v-row class="w-100">
                <v-col cols="6">
                    <div class="d-flex flex-column gap-3">
                        <div class="text-caption view-field-title">
                            Group Name
                        </div>
                        <div class="text-body-2 font-weight-bold view-field-value">
                            {{ assessmentData?.groupName }}
                        </div>
                    </div>
                </v-col>
                <v-col cols="6">
                    <div class="d-flex flex-column gap-3">
                        <div class="text-caption view-field-title">
                            User Type
                        </div>
                        <div class="text-body-2 font-weight-bold view-field-value">
                            {{ assessmentData?.assessmentUserType }}
                        </div>
                    </div>
                </v-col>
            </v-row>

            <v-row class="w-100">
                <v-col cols="6">
                    <div class="d-flex flex-column gap-3">
                        <div class="text-caption view-field-title">
                            Skills
                        </div>
                        <div class="text-body-2 font-weight-bold view-field-value">
                            <span v-for="(skill, index) in assessmentData.skills" :key="index">
                                {{ skill }}<span v-if="index !== assessmentData.skills.length - 1">, </span>
                            </span>
                        </div>
                    </div>
                </v-col>
                <v-col cols="6">
                    <div class="d-flex flex-column gap-3">
                        <div class="text-caption view-field-title">
                            Assessment Category
                        </div>
                        <div class="text-body-2 font-weight-bold view-field-value">
                            {{ categoryNameForDisplay }}
                        </div>
                    </div>
                </v-col>
            </v-row>

            <v-row class="w-100">
                <v-col cols="6">
                    <div class="d-flex flex-column gap-3">
                        <div class="text-caption view-field-title">
                            Level
                        </div>
                        <div class="text-body-2 font-weight-bold view-field-value">
                            {{ assessmentData?.level }}
                        </div>
                    </div>
                </v-col>
                <v-col cols="6">
                    <div class="d-flex flex-column gap-3">
                        <div class="text-caption view-field-title">
                            Grade
                        </div>
                        <div class="text-body-2 font-weight-bold view-field-value">
                            <span v-for="(grade, index) in assessmentData.grade" :key="index">
                                {{ grade }}<span v-if="index !== assessmentData.grade.length - 1">, </span>
                            </span>
                        </div>
                    </div>
                </v-col>
            </v-row>

            <v-row class="w-100">
                <v-col cols="6">
                    <div class="d-flex flex-column gap-3">
                        <div class="text-caption view-field-title">
                            Timer Type
                        </div>
                        <div class="text-body-2 font-weight-bold view-field-value">
                            {{ assessmentData?.timerType }}
                        </div>
                    </div>
                </v-col>
                <v-col cols="6">
                    <div class="d-flex flex-column gap-3">
                        <div class="text-caption view-field-title">
                            Language Of Questions
                        </div>
                        <div class="text-body-2 font-weight-bold view-field-value">
                            <span v-for="(language, index) in assessmentData.availableLanguages" :key="index">
                                {{ language }}<span v-if="index !== assessmentData.availableLanguages.length - 1">, </span>
                            </span>
                        </div>
                    </div>
                </v-col>
            </v-row>

            <v-row class="w-100">
                <v-col cols="6">
                    <div class="d-flex flex-column gap-3">
                        <div class="text-caption view-field-title">
                            Section/Subject
                        </div>
                        <div class="text-body-2 font-weight-bold view-field-value">
                            <span v-for="(section, index) in assessmentData.sections" :key="index">
                                {{ section.name }}<span v-if="index !== assessmentData.sections.length - 1">, </span>
                            </span>
                        </div>
                    </div>
                </v-col>
                <v-col cols="6">
                    <div class="d-flex flex-column gap-3">
                        <div class="text-caption view-field-title">
                            Total Duration
                        </div>
                        <div class="text-body-2 font-weight-bold view-field-value">
                            {{ assessmentData?.duration }}
                        </div>
                    </div>
                </v-col>
            </v-row>

            <v-row class="w-100">
                <v-col cols="6" class="d-flex align-center justify-space-between py-0">
                    <v-label class="text-body-2 view-field-title"> Include Bio-Break?</v-label>
                    <v-radio-group
                      dense
                      disabled
                      required
                      class="view-static-disabled-radio"
                      v-model="assessmentData.isBioBreakIncluded"
                    >
                        <div class="d-flex ma-0 gap-3">
                            <v-radio class="view-static-radio-option" label="YES" :value="true"></v-radio>
                            <v-radio class="view-static-radio-option" label="NO" :value="false"></v-radio>
                        </div>
                    </v-radio-group>
                </v-col>
            </v-row>

            <v-row class="w-100">
                <v-col v-if="assessmentData.isBioBreakIncluded" cols="6" class="d-flex align-center justify-space-between py-0">
                    <div class="d-flex flex-column gap-3">
                        <div class="text-caption view-field-title">
                            Bio-Break Type
                        </div>
                        <div class="text-body-2 font-weight-bold view-field-value">
                            {{ assessmentData?.breakType }}
                        </div>
                    </div>
                </v-col>
                <v-col v-if="assessmentData?.breakType?.toLowerCase() === 'break anytime'" cols="6" class="d-flex align-center justify-space-between py-0">
                    <div class="d-flex flex-column gap-3">
                        <div class="text-caption view-field-title">
                            Max Duration For Bio-Break
                        </div>
                        <div class="text-body-2 font-weight-bold view-field-value">
                            {{ assessmentData?.maxBreakDuration || 0 }} Mins
                        </div>
                    </div>
                </v-col>
            </v-row>
            
            <div class="d-flex flex-column gap-4 w-100 my-2">
                <v-card v-for="(section, index) in assessmentData?.sections" :key="section.name" elevation="2" rounded class="d-flex flex-column w-100 pa-4 gap-6">
                    <div class="text-h6 font-weight-bold section-name-color">
                        {{ section.name }}
                    </div>
                    
                    <v-row no-gutters v-if="isSelectiveSectionTimer || isBreakBetweenSections">
                        <v-col v-if="isSelectiveSectionTimer" cols="6">
                            <div class="d-flex align-center gap-6">
                                <v-label class="view-field-title"> Section Timing</v-label>
                                <v-radio-group
                                dense
                                disabled
                                required
                                class="view-static-disabled-radio"
                                v-model="section.isTimedSection"
                                >
                                    <div class="d-flex ma-0 gap-3">
                                        <v-radio class="view-static-radio-option" label="Timed" :value="true"></v-radio>
                                        <v-radio class="view-static-radio-option" label="Untimed" :value="false"></v-radio>
                                    </div>
                                </v-radio-group>
                            </div>
                        </v-col>
                        <v-col v-if="isBreakBetweenSections" cols="6">
                            <div class="d-flex flex-column gap-2">
                                <div class="text-caption view-field-title">
                                    Bio-Break After Section
                                </div>
                                <div class="text-body-2 font-weight-bold view-field-value">
                                    {{ sectionBreakDuration(section) }} Mins
                                </div>
                            </div>
                        </v-col>
                    </v-row>
    
                    <v-row no-gutters>
                        <v-col cols="6">
                            <div class="d-flex flex-column gap-2">
                                <div class="text-caption view-field-title">
                                    Duration
                                </div>
                                <div class="text-body-2 font-weight-bold view-field-value">
                                    {{ section?.duration ? section.duration + ' Mins' : 'NA' }}
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="6">
                            <div class="d-flex flex-column gap-2">
                            <div class="text-caption view-field-title">
                                No. of Questions(Per Language)
                            </div>
                            <div class="text-body-2 font-weight-bold view-field-value">
                                {{ section?.noOfQuestions }}
                            </div>
                        </div>
                        </v-col>
                    </v-row>
                </v-card>
            </div>
            
            <v-row class="w-100">
                
                <v-col cols="6">
                    <div class="d-flex flex-column gap-3">
                        <div class="text-caption view-field-title">
                            Total No of Questions (All Language)
                        </div>
                        <div class="text-body-2 font-weight-bold view-field-value">
                            {{ assessmentData?.noOfQuestion }}
                        </div>
                    </div>
                </v-col>
            </v-row>
                
            <v-row class="w-100" v-if="isSelectiveSectionTimer">
                <v-col cols="6">
                    <div class="d-flex flex-column gap-3">
                        <div class="text-caption view-field-title">
                            Timed Section Duration
                        </div>
                        <div class="text-body-2 font-weight-bold view-field-value">
                            {{ timedSectionDuration }} Mins
                        </div>
                    </div>
                </v-col>
                <v-col cols="6">
                    <div class="d-flex flex-column gap-3">
                        <div class="text-caption view-field-title">
                            Untimed Section Duration
                        </div>
                        <div class="text-body-2 font-weight-bold view-field-value">
                            {{ untimedSectionDuration }} Mins
                        </div>
                    </div>
                </v-col>
            </v-row>

            <v-row class="w-100 mb-2">
                <v-col cols="6" class="d-flex align-center justify-space-between py-0" >
                <v-label class="text-body-2 view-field-title"> Reshuffle Required?</v-label>
                <v-radio-group
                  dense 
                  disabled
                  required
                  class="view-static-disabled-radio"
                  v-model="assessmentData.isReshuffleRequired"
                >
                    <div class="d-flex ma-0 gap-3">
                    <v-radio class="view-static-radio-option" label="YES" value="YES"></v-radio>
                    <v-radio class="view-static-radio-option" label="NO" value="NO"></v-radio>
                    </div>
                </v-radio-group>
                </v-col>
            </v-row>

            <v-card class="w-100">
                <v-data-table
                  :headers="headers"
                  :items="allQuestions"
                  :items-per-page="tablePageSize"
                  item-key="questionId"
                  class="custom-table no-table-outline"
                  :options.sync="options"
                  hide-default-footer
                  ref="myTable"
                  :class="isScrollable ? 'frozen-columns-table' : ''"
                >
                  <template v-slot:[`item.questionStatement`]="{ item }">
                    <v-tooltip bottom max-width="40vw">
                      <template #activator="{ on }">
                        <div v-on="on" class="question-statement-cell">
                            {{ stripHtml(item.questionStatement) }}
                        </div>
                      </template>
                      <div v-html="item.questionStatement"></div>
                    </v-tooltip>
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="d-flex justify-center w-100">
                        <img
                          width="28px"
                          height="28px"
                          class="cursor"
                          :src="viewQuestionIcon"
                          @click="redirectToViewQuestion(item.questionId)"
                        />
                    </div>
                  </template>

                  <template v-slot:no-data>
                    <div class="custom-no-data" style="height: 120px;">
                      <p>No Data Available</p>
                    </div>
                  </template>
                  <template v-slot:footer="{ props }">
                    <table-footer
                      :pagination="props.pagination"
                      :options="props.options"
                      @update-options="onFooterUpdate"
                    />
                  </template>
                </v-data-table>
            </v-card>
            
        </v-card>
    </div>
</template>
<script>
import "../styles.css";
import StaticAssessmentController from "@/controllers/StaticAssessmentController";
import SkillsController from "@/controllers/SkillsController";
import AudienceRolesController from "@/controllers/AudienceRolesController";
import UserNavMenu from "@/components/UserNavMenu.vue";
import isTableScrollableMixin from "@/mixins/isTableScrollableMixin";
export default {
    components: {
        UserNavMenu,
    },
    name: "ViewStaticAssessmentView",
    mixins: [ isTableScrollableMixin ],
    data(){
        return{
            preloader:  false,
            assessmentData: {},
            allQuestions: [],
            tablePageSize: 10,
            options: { page: 1, itemsPerPage: 10 },
            viewQuestionIcon: require('@/assets/view.svg'),
            skillsList: [],
            assessmentCategoriesList: [],
            categoryNameForDisplay: "",
            headers: [
              { text: "Question ID", value: "questionId", width: "12%", class: "assessment-table-header", cellClass: "assessment-table-cell" },
              { text: "Question Statement", value: "questionStatement", width: "30%", class: "assessment-table-header", cellClass: "assessment-table-cell" },
              { text: "Skill", value: "skill", width: "12%", class: "assessment-table-header", cellClass: "assessment-table-cell" },
              { text: "Strand", value: "strand", width: "10%", class: "assessment-table-header", cellClass: "assessment-table-cell question-statement-cell" },
              { text: "Sub Strand", value: "subStrand", width: "14%", class: "assessment-table-header", cellClass: "assessment-table-cell question-statement-cell" },
              { text: "Difficulty Level", value: "difficultyLevel", width: "14%", class: "assessment-table-header", cellClass: "assessment-table-cell" },
              { text: "Grade", value: "grade", width: "10%", class: "assessment-table-header", cellClass: "assessment-table-cell question-statement-cell" },
              { text: "Actions", value: "actions", sortable: false, width: "8%", class: "assessment-table-header", cellClass: "assessment-table-cell" },
            ],
        }
    },
    computed: {
        isSelectiveSectionTimer() {
            return this.assessmentData?.timerType === "Selective Section Timer";
        },
        isBreakBetweenSections() {
            return this.assessmentData?.breakType === "Break Between Sections";
        },
        timedSectionDuration() {
            const sections = this.assessmentData?.sections || [];
            return sections
                .filter(({ isTimedSection }) => isTimedSection)
                .reduce((sum, { duration }) => sum + (Number(duration) || 0), 0);
        },
        untimedSectionDuration() {
            const totalDuration = Number(this.assessmentData?.duration) || 0;
            return Math.max(0, totalDuration - this.timedSectionDuration);
        },
    },
    async created (){
        this.preloader = true;
        try {
            await Promise.all([
                this.getSkills(),
                this.getAssessmentForId(this.$route.query.id),
            ]);
            await this.resolveAssessmentCategoryName();
        } finally {
            this.preloader = false;
        }
    },
    methods: {
        sectionBreakDuration(section) {
            if (this.isSelectiveSectionTimer) {
                return Number(section?.breakDuration) || 0;
            }
            const sectionCount = this.assessmentData?.sections?.length || 0;
            if (!sectionCount) {
                return 0;
            }
            return Math.round((Number(this.assessmentData?.maxBreakDuration) || 0) / sectionCount);
        },
        async getAssessmentForId(id) {
            // this.assessmentData.id = id;
            let response = await StaticAssessmentController.getStaticAssessmentsById(id);
            const { assessments, flag } = response?.data;
            if (flag) {
                this.assessmentData = { ...assessments[0], id }
                this.allQuestions.push(...this.getQuestionsForLanguage("English", this.assessmentData.questions));
            }
        },
        async getSkills() {
            try {
                const response = await SkillsController.getSkills();
                this.skillsList = response?.status && Array.isArray(response?.data?.skills)
                    ? response.data.skills
                    : [];
            }
            catch (error) {
                console.error(error);
                this.skillsList = [];
            }
        },
        getSkillIdsForAssessment(skills = []) {
            if (!Array.isArray(skills) || skills.length === 0) {
                return [];
            }

            const availableSkillIds = new Set(
                this.skillsList
                    .map(({ id }) => id)
                    .filter((id) => id !== undefined && id !== null)
            );
            const allSkillsAreIds = skills.every((skill) => availableSkillIds.has(skill));
            if (allSkillsAreIds) {
                return skills;
            }

            return this.skillsList
                .filter(({ id, name }) => skills.includes(id) || skills.includes(name))
                .map(({ id }) => id);
        },
        async resolveAssessmentCategoryName() {
            if (!this.assessmentData || Object.keys(this.assessmentData).length === 0) {
                return;
            }
            const skillIds = this.getSkillIdsForAssessment(this.assessmentData?.skills);
            await this.fetchAssessmentCategories(skillIds);
            this.categoryNameForDisplay = this.getDisplayNameForId(
                this.assessmentData?.assessmentCategory,
                this.assessmentCategoriesList
            );
        },
        async fetchAssessmentCategories(skillIds = []){
            if (!Array.isArray(skillIds) || skillIds.length === 0) {
                this.assessmentCategoriesList = [];
                return;
            }
            const { assessmentCategories, flag } = await AudienceRolesController.fetchAssessmentCategories(skillIds);
            this.assessmentCategoriesList = flag ? assessmentCategories ?? [] : [];
        },
        getDisplayNameForId(targetId, list = []) {
            return list.find(({ id }) => id === targetId)?.name || targetId;
        },
        getQuestionsForLanguage(language, questions) {
            //'questions' can be of two types, transformed(as stored in db) or untransformed(as on csv upload)
            //This function can filter either type or a composite array of questions consisting of both types simultaneously
            let questionsOfLanguage = [];
            questions.forEach(({ QuestionDetails, languageOfQuestion, ...rest }) => {
                if (QuestionDetails) {
                questionsOfLanguage.push({
                    questionStatement:
                    QuestionDetails[language?.toLowerCase()]?.questionStatement,
                    strand: QuestionDetails[language?.toLowerCase()]?.strand || 'NA',
                    subStrand: QuestionDetails[language?.toLowerCase()]?.subStrand || 'NA',
                    ...rest,
                });
                } else if (languageOfQuestion === language) {
                questionsOfLanguage.push({ languageOfQuestion, ...rest });
                }
            });
            return questionsOfLanguage;
        },
        onFooterUpdate(newOptions) {
            this.options = { ...this.options, ...newOptions };
        },
        redirectToViewQuestion(questionId) {
            this.$store.dispatch("setAssessmentData", this.assessmentData);
            this.$router.push({
                path: "/assessment-listing-question",
                query: { questionId },
            });
        },
        stripHtml(html){
            const tmp = document.createElement('div')
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || ''
        },
    }
}
</script>
<style>
.view-assessment-card {
  margin-top: 64px !important;
}
.view-assessment-card .col,
.view-assessment-card [class*="col-"] {
  padding: 0 !important;
}
.title-text{
    color: #666666;
}
.view-field-title,
.view-field-value {
  color: var(--gray) !important;
}
.section-name-color {
  color: #212121 !important;
}
.question-statement-cell {
  max-width: 360px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.no-table-outline {
  box-shadow: none !important;
  border: none !important;
}
.no-table-outline.v-data-table {
  box-shadow: none !important;
}
.no-table-outline .v-data-table__wrapper {
  border: none !important;
}
.no-table-outline .assessment-table-header {
  font-size: 14px !important;
  font-weight: 500 !important;
  font-family: "GraphikMedium", sans-serif !important;
}
.no-table-outline .assessment-table-cell {
  font-size: 14px !important;
  font-weight: 400 !important;
}
.view-static-disabled-radio.v-input--is-disabled .v-icon {
  color: rgba(0, 0, 0, 0.38) !important;
}
.view-static-disabled-radio.v-input--is-disabled .v-label {
  color: rgba(0, 0, 0, 0.38) !important;
}
.view-static-disabled-radio {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
.view-static-disabled-radio .v-input__slot {
  margin-bottom: 0 !important;
}
.view-static-disabled-radio .v-messages {
  display: none !important;
}
.view-static-disabled-radio .v-radio,
.view-static-disabled-radio .v-input--selection-controls {
  margin: 0 !important;
  padding: 0 !important;
}
.view-static-radio-option {
  padding: 0 12px !important;
}
.view-static-radio-option .v-label {
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 20px !important;
}
</style>